import React, { useEffect } from 'react';
import { getContent } from '@plone/volto/actions/content/content';
import Body from '@plone/volto/components/manage/Blocks/Video/Body';
import VideoSidebar from '@plone/volto/components/manage/Blocks/Video/VideoSidebar';
import SidebarPortal from '@plone/volto/components/manage/Sidebar/SidebarPortal';
import Image from '@plone/volto/components/theme/Image/Image';
import { withBlockExtensions } from '@plone/volto/helpers/Extensions';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { defineMessages, useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { Message } from 'semantic-ui-react';

import {
  buildVideoUrlFromFile,
  getSelectedExternalUrlFromItem,
  getSelectedUrlItem,
  getSelectedVideoPath,
  getVideoSubrequestId,
  normalizeLegacyUrlValue,
} from './utils';

import videoBlockSVG from '@plone/volto/components/manage/Blocks/Video/block-video.svg';

const messages = defineMessages({
  VideoFormDescription: {
    id: 'Select an internal Video item or type an external URL',
    defaultMessage: 'Select an internal Video item or type an external URL',
  },
});

const Edit = (props) => {
  const { data, block, selected, onChangeBlock } = props;
  const intl = useIntl();
  const dispatch = useDispatch();

  useEffect(() => {
    const normalizedUrl = normalizeLegacyUrlValue(data.url);
    if (!normalizedUrl) return;

    onChangeBlock(block, {
      ...data,
      url: normalizedUrl,
    });
  }, [block, data, onChangeBlock]);

  const selectedVideoItem = getSelectedUrlItem(data.url);
  const selectedUrl = typeof data.url === 'string' ? data.url.trim() : '';
  const selectedExternalUrlFromItem =
    getSelectedExternalUrlFromItem(selectedVideoItem);
  const selectedVideoPath = getSelectedVideoPath(selectedVideoItem);
  const selectedVideoSubrequest = getVideoSubrequestId(
    block,
    selectedVideoPath,
    'edit',
  );
  const selectedVideoData = useSelector(
    (state) => state.content.subrequests?.[selectedVideoSubrequest]?.data,
  );

  useEffect(() => {
    if (!selectedVideoPath) return;
    dispatch(getContent(selectedVideoPath, null, selectedVideoSubrequest));
  }, [dispatch, selectedVideoPath, selectedVideoSubrequest]);

  const selectedVideoUrl = selectedVideoData?.url || '';
  const selectedVideoFileUrl = buildVideoUrlFromFile(selectedVideoData?.file);

  const resolvedUrl =
    selectedUrl ||
    selectedExternalUrlFromItem ||
    selectedVideoUrl ||
    selectedVideoFileUrl;

  return (
    <div
      className={cx(
        'block video align',
        {
          selected: selected,
          center: !Boolean(data.align),
        },
        data.align,
      )}
    >
      {resolvedUrl ? (
        <Body data={{ ...data, url: resolvedUrl }} isEditMode={true} />
      ) : (
        <Message>
          <center>
            <Image src={videoBlockSVG} alt="" />
            <p>{intl.formatMessage(messages.VideoFormDescription)}</p>
          </center>
        </Message>
      )}
      <SidebarPortal selected={selected}>
        <VideoSidebar {...props} />
      </SidebarPortal>
    </div>
  );
};

Edit.propTypes = {
  selected: PropTypes.bool.isRequired,
  block: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  onChangeBlock: PropTypes.func.isRequired,
  onSelectBlock: PropTypes.func.isRequired,
  onDeleteBlock: PropTypes.func.isRequired,
  onFocusPreviousBlock: PropTypes.func.isRequired,
  onFocusNextBlock: PropTypes.func.isRequired,
  handleKeyDown: PropTypes.func.isRequired,
};

export default withBlockExtensions(Edit);
